module.exports = __webpack_public_path__ + "static/media/dark_icn_map_fermata_scambio_capolinea.8e6b14fb.svg";